import { BaseNotificationContextEnum } from './base-notification-context.enum';

/**
 * Vehicle notification context enum
 * @description Notification contexts specific to vehicle subjects
 */
export enum VehicleNotificationContextEnum {
	// Base contexts
	INSERTED = BaseNotificationContextEnum.INSERTED,
	UPDATED = BaseNotificationContextEnum.UPDATED,
	DELETED = BaseNotificationContextEnum.DELETED,

	// Vehicle-specific contexts
	IN_PARK = 'in_park',
	HARD_HOLD = 'hard_hold',
	OUT_OF_SERVICE = 'out_of_service',
	RESERVED = 'reserved',
	RENTED = 'rented',
	RESERVED_MAINTENANCE = 'reserved_maintenance',
	IN_MAINTENANCE = 'in_maintenance',
}
